<swiper-container
  #container
  init="false"
  [class.autoHeight]="config()?.autoHeight"
  [modules]="swiperModules"
  (swiperslidechange)="slideChanged.emit($any($event).detail[0])"
  (swipertransitionstart)="transitionStarted.emit($any($event).detail[0])"
  (swipertransitionend)="transitionEnded.emit($any($event).detail[0])"
  (swipertouchend)="touchEnded.emit($any($event).detail[0])"
  (swiperreachend)="reachEnd.emit($any($event).detail[0])"
  (swiperreachbeginning)="reachBeginning.emit($any($event).detail[0])"
  (swipersnapindexchange)="snapIndexChange.emit($any($event).detail[0])"
>
  @for (slide of swiperSlides; track $index; let i = $index) {
    <swiper-slide>
      <ng-container *ngTemplateOutlet="slide" />
    </swiper-slide>
  }
</swiper-container>
